import React, { useState } from "react";
import { Button } from "../../../../../../../components/button.jsx";

export function StepMapping({ file, setFile }) {
  let [mapping, setMapping] = useState(file.mapping || {});
  let mappableColumns = [
    "date",
    "amount",
    "currency",
    "counterpart",
    "description",
    "reference",
  ];
  let { data, name } = file;
  let [removedLines, setRemovedLines] = useState([]);
  let sheet = data[0].data;

  let numCols =
    Math.max(
      ...sheet
        .map((row, rowIndex) => {
          return Math.max(...row.map((col, colIndex) => colIndex));
        })
        .filter((x) => !!x)
    ) + 1;

  function map() {
    window.localStorage.importMapping = JSON.stringify(mapping);
    return setFile({ ...file, step: "confirm", mapping, removedLines });
  }

  return (
    <div className={"flex flex-col gap-3"}>
      <div className={"w-full h-full overflow-auto"} style={{ height: 400 }}>
        <table>
          <thead>
            <tr>
              <th></th>
              {Array.from(Array(numCols)).map((_, colIndex) => (
                <th>
                  <div className={"flex flex-col gap-0.5"}>
                    <select
                      className={
                        "p-3 rounded border border-gray-400 bg-white cursor-pointer w-full"
                      }
                      onChange={(e) =>
                        setMapping({ ...mapping, [colIndex]: e.target.value })
                      }
                      style={{ minWidth: 100 }}
                      value={mapping[colIndex]}
                    >
                      <option value={""}></option>
                      {mappableColumns
                        .filter(
                          (mappableColumn) =>
                            !Object.values(mapping).includes(mappableColumn) ||
                            mapping[colIndex] === mappableColumn
                        )
                        .map((mappableColumn) => (
                          <option value={mappableColumn}>
                            {mappableColumn}
                          </option>
                        ))}
                    </select>
                    {mapping[colIndex] === "date" && (
                      <select
                        className={
                          "p-3 rounded border border-gray-400 bg-white cursor-pointer w-full"
                        }
                        onChange={(e) =>
                          setMapping({ ...mapping, dateFormat: e.target.value })
                        }
                        style={{ minWidth: 200 }}
                        value={mapping["dateFormat"]}
                      >
                        <option value={""}></option>
                        <option>yyyy-MM-dd</option>
                        <option>dd-MM-yyyy</option>
                        <option>MM-dd-yyyy</option>
                      </select>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sheet.map(
              (row, rowIndex) =>
                !removedLines.includes(rowIndex) && (
                  <tr>
                    <td>
                      <Button
                        onClick={() => {
                          setRemovedLines(
                            Array.from(new Set([...removedLines, rowIndex]))
                          );
                        }}
                        sizing={"s"}
                        className={"mr-1"}
                      >
                        <div className={"px-2"}>
                          <span className={"fa fa-times"} />
                        </div>
                      </Button>
                    </td>
                    {Array.from(Array(numCols)).map((_, colIndex) => (
                      <td
                        className={
                          "p-2 whitespace-pre overflow-ellipsis overflow-hidden"
                        }
                        style={{ maxWidth: 200 }}
                      >
                        {row[colIndex]}
                      </td>
                    ))}
                  </tr>
                )
            )}
          </tbody>
        </table>
      </div>

      <div className={"flex"}>
        <div className={"flex-grow"}>
          Please map your columns, then, click on import.
        </div>

        <Button onClick={() => map()}>continue</Button>
      </div>
    </div>
  );
}
